export class DAEAttributes {
  public daeIsMonitored = false;
  public daeSerialNumber?: string;
  public daeBatteryExpireDate?: Date;
  public daeElectrodeExpireDate?: Date;
}
